import React from 'react';
import { useTranslation } from 'react-i18next';
import './style.css'

const Bookings = () => {
    const { t, i18n } = useTranslation();
    const locale = i18n.language === 'en' ? 'en_US' : 'th_TH';
    
    return(
        <div id="Bookings" className="contact-area section-padding">
            <div className="container">
                <div className="wpo-contact-info">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="info-item">
                                <a href={`https://booking.ezseat.asia/checkin-counters?appkey=26b0df8f436dd61564d1ade0f1b24250&locale=${locale}`} target="_blank" rel="noopener noreferrer">
                                    <div className="info-wrap">
                                        <div className="info-icon">
                                            <i className="fi flaticon-internet"></i>
                                        </div>
                                        <div className="info-text">
                                            <span>{t('bookings.check_in_counter')}</span>
                                        </div>
                                    </div>
                                    <h2>{t('bookings.find_counter')}</h2>
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="info-item">
                                <a href={`https://booking.ezseat.asia/booking-status?appkey=26b0df8f436dd61564d1ade0f1b24250&locale=${locale}`} target="_blank" rel="noopener noreferrer">
                                    <div className="info-wrap">
                                        <div className="info-icon">
                                            <i className="fi flaticon-null-1"></i>
                                        </div>
                                        <div className="info-text">
                                            <span>{t('bookings.booking_status')}</span>
                                        </div>
                                    </div>
                                    <h2>{t('bookings.check_status')}</h2>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
     )
}

export default Bookings;
